// app/utils/breakpoints.ts

export const breakpoints = {
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	'2xl': 1536,
}

export const mediaQueries = {
	// General queries (min-width, or 'X-up')
	sm: `(min-width: ${breakpoints.sm}px)`, // sm and up
	md: `(min-width: ${breakpoints.md}px)`, // md and up (often desktop first)
	lg: `(min-width: ${breakpoints.lg}px)`, // lg and up
	xl: `(min-width: ${breakpoints.xl}px)`, // xl and up
	'2xl': `(min-width: ${breakpoints['2xl']}px)`, // 2xl and up

	// Specific "down" queries (max-width, or 'X-down')
	// This is your 'svp' (small viewport) from before, effectively 'md-down'
	'md-down': `(max-width: ${breakpoints.md - 1}px)`, // screens up to 767px (mobile/tablet)

	// This is your 'mvp-down' (if MVP means something like 'lg' breakpoint)
	// Let's assume 'MVP' for you means 'md' breakpoint, so 'mvp-down' would mean screens up to 767px.
	// If 'MVP' for you means 'lg' breakpoint, then 'mvp-down' would be `(max-width: ${breakpoints.lg - 1}px)`.
	// I'll assume 'MVP' refers to screens starting from 'md', so 'mvp-down' is 'md-down'
	'mvp-down': `(max-width: ${breakpoints.md - 1}px)`, // Same as md-down, clarifies intent

	// 'lvp-up' (Large Viewport Up)
	// Assuming 'LVP' for you means starting from 'lg' breakpoint
	'lvp-up': `(min-width: ${breakpoints.lg}px)`, // lg and up

	// Add more as needed, e.g., 'sm-down', 'lg-down', etc.
	'sm-down': `(max-width: ${breakpoints.sm - 1}px)`,
	'lg-down': `(max-width: ${breakpoints.lg - 1}px)`,
}
